module.exports = __webpack_public_path__ + "img/T4-A-rc_10.b86988ac.png";